export default __webpack_public_path__ + "static/ronaldo-bde40774823c8287f1d828a0a304c8cf.png";